import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { INDEX, LANDING, LOGIN } from "../../constants/ROUTER_PATH_TITLE";

const IndexPage = () => {
  const navigate = useNavigate();

  document.title = INDEX.TITLE();

  useEffect(() => {
    if (window.tconfig.ROOT_PATH && window.tconfig.ROOT_PATH !== "") {
      navigate(window.tconfig.ROOT_PATH);
    } else if (window.tconfig.SHOW_LANDING_PAGE) {
      navigate(LANDING.PATH);
    } else {
      navigate(LOGIN.PATH);
    }
  }, [navigate]);

  return <></>;
};

export default IndexPage;
